import { render, staticRenderFns } from "./CertificadoDeFinalizacion.vue?vue&type=template&id=2b9f8524&scoped=true"
import script from "./CertificadoDeFinalizacion.vue?vue&type=script&lang=js"
export * from "./CertificadoDeFinalizacion.vue?vue&type=script&lang=js"
import style0 from "./CertificadoDeFinalizacion.vue?vue&type=style&index=0&id=2b9f8524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f8524",
  null
  
)

export default component.exports